import Objectif from "./Users/Objectifs";

const Dashboard = ({ AppStore, ...props }) => {
  return <Objectif AppStore={AppStore} />;
};

export default Dashboard;
